var dict = {
  "app_id": 208539,
  "videoList": [
    {
      "date": "",
      "title": "金融基础设施网络安全合规遵从与落地实践",
      "vid": "q3215gz84gv",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%20%E8%A2%81%E6%85%A7%E8%90%8D-%E9%87%91%E8%9E%8D%E5%9F%BA%E7%A1%80%E8%AE%BE%E6%96%BD%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E5%90%88%E8%A7%84%E9%81%B5%E4%BB%8E%E4%B8%8E%E8%90%BD%E5%9C%B0%E5%AE%9E%E8%B7%B5.mp4",
      "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/act/jinrong-bg-4.png"
    },
    {
      "date": "",
      "title": "工商银行信息安全体系建设实践",
      "vid": "y3215qp47ou",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%E7%BD%97%E6%AF%85-%E5%B7%A5%E5%95%86%E9%93%B6%E8%A1%8C%E4%BF%A1%E6%81%AF%E5%AE%89%E5%85%A8%E4%BD%93%E7%B3%BB%E5%BB%BA%E8%AE%BE%E5%AE%9E%E8%B7%B5.mp4",
      "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/act/jinrong-bg-2.png"
    },
    {
      "date": "",
      "title": "以对抗为核心的金融网络安全运营实践",
      "vid": "c3215e6rltj",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%E4%B8%81%E6%B5%B7%E8%99%B9-%20%E4%BB%A5%E5%AF%B9%E6%8A%97%E4%B8%BA%E6%A0%B8%E5%BF%83%E7%9A%84%E9%87%91%E8%9E%8D%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E8%BF%90%E8%90%A5%E5%AE%9E%E8%B7%B5.mp4",
      "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/act/jinrong-bg-3.png"
    },
    {
      "date": "",
      "title": "证券行业网络安全体系建设实践",
      "vid": "p32152gjl4f",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%E5%96%BB%E5%8D%8E%E4%B8%BD-%E8%AF%81%E5%88%B8%E8%A1%8C%E4%B8%9A%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E4%BD%93%E7%B3%BB%E5%BB%BA%E8%AE%BE%E5%AE%9E%E8%B7%B5.mp4",
      "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/act/jinrong-bg-1.png"
    },
    {
      "date": "",
      "title": "创新环境下中小银行数据安全管控思考与实践",
      "vid": "o3215poanpe",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%E7%8E%8B%E5%BF%83%E7%8E%89-%E5%88%9B%E6%96%B0%E7%8E%AF%E5%A2%83%E4%B8%8B%E4%B8%AD%E5%B0%8F%E9%93%B6%E8%A1%8C%E6%95%B0%E6%8D%AE%E5%AE%89%E5%85%A8%E7%AE%A1%E6%8E%A7%E6%80%9D%E8%80%83%E4%B8%8E%E5%AE%9E%E8%B7%B5.mp4",
      "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/act/jinrong-bg-1.png"
    },
    {
      "date": "",
      "title": "渠道转型中安全架构的演进趋势",
      "vid": "s3215c2mkpg",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%E6%BD%98%E6%B6%A6%E7%BA%A2-%E8%87%B4%E8%BE%9E.mp4",
      "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/act/jinrong-bg-1.png"
    }
  ],
  "exhibitionId": "485b382f92e7489db51970f9abd4d531",
  "projectId": "ca7ba1cfef3d4aa9b1440add96573398",
  "AppId": ""
}

export default dict;